import React from 'react';
import { Button, WrapButton } from './styles';
import { subjectTypes } from '../../@types/entities/subjects.entity';
import ArrowDown from '../../assets/icons/arrow-down';

interface Props {
  path: string;
  subject: subjectTypes | string;
  label?: string;
}

export default function Attachment({ path, subject, label }: Props) {
  return (
    <WrapButton>
      <Button
        $color={10}
        href={require(`../../assets/attachments/${path}`)}
        download
        target="_blank"
        $subject={subject}
      >
        {(!label || label?.trim() === '') ? 'Baixe o arquivo anexo' : label}
        <ArrowDown />
      </Button>
    </WrapButton>
  );
}
